var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_943_38442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5V9.16667M10 12.5V12.5083",
    stroke: "#BA8D5B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22488 15.8325H15.8332C16.0987 15.8188 16.3571 15.7418 16.5868 15.6079C16.8165 15.474 17.0108 15.2871 17.1535 15.0628C17.2962 14.8385 17.3832 14.5833 17.4073 14.3185C17.4313 14.0538 17.3916 13.7871 17.2915 13.5408L11.4582 3.33245C11.3141 3.07195 11.1028 2.85481 10.8463 2.70361C10.5899 2.5524 10.2976 2.47266 9.99988 2.47266C9.70216 2.47266 9.40988 2.5524 9.15342 2.70361C8.89696 2.85481 8.68568 3.07195 8.54155 3.33245L2.70822 13.5408C2.60817 13.7871 2.56849 14.0538 2.59251 14.3185C2.61652 14.5833 2.70353 14.8385 2.84626 15.0628C2.98899 15.2871 3.18331 15.474 3.41299 15.6079C3.64267 15.7418 3.90104 15.8188 4.16655 15.8325",
    stroke: "#BA8D5B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_943_38442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.52b4057162ee9d37c7c402856beaebfd.svg";
export { ForwardRef as ReactComponent };